import { IMAGE_TYPES } from "config/constants";

export default function(imageRequirements) {
  const imageNames = Object.values(IMAGE_TYPES)
    .map(x => x.name)
    .join(" or ");

  if (imageRequirements.minWidth && imageRequirements.minHeight) {
    return `This image must be at least ${imageRequirements.minWidth}px x ${imageRequirements.minHeight}px and formatted as ${imageNames}`;
  } else if (imageRequirements.minWidth) {
    return `This image must be at least ${imageRequirements.minWidth}px wide and formatted as ${imageNames}`;
  } else if (imageRequirements.minHeight) {
    return `This image must be at least ${imageRequirements.minHeight}px tall and formatted as ${imageNames}`;
  } else {
    return `This image must be formatted as ${imageNames}`;
  }
}
